import { render, staticRenderFns } from "./WsFlex.vue?vue&type=template&id=be15b770&"
import script from "./WsFlex.vue?vue&type=script&lang=js&"
export * from "./WsFlex.vue?vue&type=script&lang=js&"
import style0 from "./WsFlex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports